export default __webpack_public_path__ + "static/media/CoverageOptions.ea4ff95a.svg";